/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa Currency Converter
 *
 */
Intesa.CurrencyConverter = function() {
	
    /**
	 *  Variables
	 *
	 */
	var currencyConverter = this;
	var urlCurrencyJson="";
	var genericSettings = {};
	var regexSeparator = null;
	var regexDecimal = null;
	var bankName = $("[data-bank]").attr('data-bank');

	if ($("[data-url-fortimedate]").length>0){

		urlCurrencyJson = $("[data-url-fortimedate]").attr("data-url-fortimedate");
	}

	currencyConverter.localCurrencyLbl = "";
	currencyConverter.numeralDecimalScale = 2;

	if (urlCurrencyJson) {
		try {
			$.ajax({
				url: urlCurrencyJson, 
				success: function(result){
					currencyConverter.cJson = result;
					if (result === null){
						currencyConverter.cJson = JSON.parse('{}');
						console.error( 'The currency service is null' );
					} else {

						if (bankName == "ISPBIH") {
							var tmpJSON = { rates: [] };

							result.rates.forEach(function (item, index) {
								tmpJSON.rates[index] = JSON.parse('{"buyRateCash": {"currencyFrom": {"code": "977", "label": "BAM", "localizedLabel": "BAM"}, "currencyTo": {"code": "' + item.currencyCode + '", "label": "' + item.currencyName + '", "localizedLabel": "' + item.currencyName + '"}, "rate": ' + item.buyingRate + ', "units": ' + item.unit + '}, "defined": "'+ item.defined + '", "fromCurrency": {"code": "977", "label": "BAM", "localizedLabel": "BAM"}, "institiution": "ISPBIH", "meanRate": {"currencyFrom": {"code": "977", "label": "BAM", "localizedLabel": "BAM"}, "currencyTo": {"code": "' + item.currencyCode + '", "label": "' + item.currencyName + '", "localizedLabel": "' + item.currencyName + '"}, "rate": ' + item.midRate + ', "units": ' + item.unit + '}, "sellingRateCash": {"currencyFrom": {"code": "977", "label": "BAM", "localizedLabel": "BAM"}, "currencyTo": {"code": "' + item.currencyCode + '", "label": "' + item.currencyName + '", "localizedLabel": "' + item.currencyName + '"}, "rate": ' + item.sellingRate + ', "units": ' + item.unit + '}, "buyRate": {"currencyFrom": {"code": "977", "label": "BAM", "localizedLabel": "BAM"}, "currencyTo": {"code": "' + item.currencyCode + '", "label": "' + item.currencyName + '", "localizedLabel": "' + item.currencyName + '"}, "rate": ' + item.buyingRateForeign + ', "units":' + item.unit + '}, "sellingRate": {"currencyFrom": {"code": "977", "label": "BAM", "localizedLabel": "BAM"}, "currencyTo": {"code": "' + item.currencyCode + '", "label": "' + item.currencyName + '", "localizedLabel": "' + item.currencyName + '"}, "rate": ' + item.sellingRateForeign + ', "units":' + item.unit + '}, "toCurrency":  {"code": "' + item.currencyCode + '", "label": "' + item.currencyName + '", "localizedLabel": "' + item.currencyName + '"}, "validFromDate": "'+ item.validFromDate + '"}');
							});

							currencyConverter.cJson = tmpJSON;
						} 
						
						if($("[data-cash-no-cash-currency]").length>0){
							
							var fromAmountCurrencyDefault = $('[data-cash-no-cash-currency="converterCurrencyDefault"]').val();
							
							if($('[data-cash-no-cash-currency="currenciesToAdd"]').length>0){
								
								var counterCurrency = 0;
								var currencyCodeDefault = 0;
								var currencyCodeDefaultAlreadyAdded = false;
								if (bankName == "ISPBIH") {
									currencyCodeDefault = 977;
								}
								currencyConverter.cJson.rates.sort(function(a, b) {
									if (parseInt(a.toCurrency.code) > parseInt(b.toCurrency.code)) {
										return 1;
									} else if (parseInt(a.toCurrency.code) < parseInt(b.toCurrency.code)) {
										return -1;
									} else {
										return 0;
									}
								});
								currencyConverter.cJson.rates.forEach(function (item) {
									if (bankName == "ISPBIH" && parseInt(item.toCurrency.code) > currencyCodeDefault && ! currencyCodeDefaultAlreadyAdded) {
										$('select[data-cash-no-cash-currency="toAmountCurrency"]').append(new Option(fromAmountCurrencyDefault, fromAmountCurrencyDefault));
										$('select[data-cash-no-cash-currency="resultAmountFXCurrency"]').append(new Option(fromAmountCurrencyDefault, fromAmountCurrencyDefault));
										$('select[data-cash-no-cash-currency="resultAmountCashCurrency"]').append(new Option(fromAmountCurrencyDefault, fromAmountCurrencyDefault));
										$('select[data-cash-no-cash-currency="fromAmountCurrency"]').append(new Option(fromAmountCurrencyDefault, fromAmountCurrencyDefault));
										currencyCodeDefaultAlreadyAdded = true;
										counterCurrency = counterCurrency + 1;
									}
									$('select[data-cash-no-cash-currency="toAmountCurrency"]').append(new Option(item.toCurrency.label, item.toCurrency.label));
									$('select[data-cash-no-cash-currency="resultAmountFXCurrency"]').append(new Option(item.toCurrency.label, item.toCurrency.label));
									$('select[data-cash-no-cash-currency="resultAmountCashCurrency"]').append(new Option(item.toCurrency.label, item.toCurrency.label));
									$('select[data-cash-no-cash-currency="fromAmountCurrency"]').append(new Option(item.toCurrency.label, item.toCurrency.label));
									if(item.toCurrency.label == $("[data-cash-no-cash-currency=toAmountCurrencyDefault]").val()){
										$('[data-cash-no-cash-currency="toAmountCurrency"] option')[counterCurrency].selected = true;
										$('[data-cash-no-cash-currency="resultAmountFXCurrency"] option')[counterCurrency].selected = true;
										$('[data-cash-no-cash-currency="resultAmountCashCurrency"] option')[counterCurrency].selected = true;
									}
									if(item.toCurrency.label == $("[data-cash-no-cash-currency=fromAmountCurrencyDefault]").val()){
										$('[data-cash-no-cash-currency="fromAmountCurrency"] option')[counterCurrency].selected = true;
									}
									counterCurrency = counterCurrency + 1;
								});
								
								if($('[data-cash-no-cash-currency="fromAmountCurrencyDefault"]').val() == fromAmountCurrencyDefault){
									$('[data-cash-no-cash-currency="fromAmountCurrency"] option[value="'+fromAmountCurrencyDefault+'"]').get(0).selected = true;
								}
								if($('[data-cash-no-cash-currency="toAmountCurrencyDefault"]').val() == fromAmountCurrencyDefault){
									$('[data-cash-no-cash-currency="toAmountCurrency"] option[value="'+fromAmountCurrencyDefault+'"]').get(0).selected = true;
								}
								
							}
							
							$('[data-cash-no-cash-currency="toAmountCurrency"]').trigger("change");
						}

						// Get local currency from response: get first rate's fromCurrency because fromCurrency is always the local currency
						currencyConverter.localCurrencyLbl = currencyConverter.cJson.rates ?
															 currencyConverter.cJson.rates[0].fromCurrency.label : '';
						if (currencyConverter.localCurrencyLbl=="HRK") {
							currencyConverter.numeralDecimalScale = 6;
						}

						//Add bank to enable it to the new logic of CR-1324
						if(bankName == "VUB"){
							currencyConverter.cJson.rates.forEach(function (item) {
								$('select[name="selectedToCurrencyCode"]').append(new Option(item.toCurrency.label, item.toCurrency.label));
							});
						}
						
					}
				}
			});	
		} catch(e) {
			currencyConverter.cJson = JSON.parse('{}');
			console.error( 'The currency service is not responding' );
		}
	}

	/**
	 * Get Settings Json Data
	 *
	 */
	this.getSettingsAndLabelsJsonData = function() {

		var settings = $( "#genericSettings" );

		try {

			// get generic settings
			if( settings.length ) {
				genericSettings = JSON.parse( settings.val() );
			}

		} catch(e) {

			console.error( 'Settings JSON file invalid' );

		}

	};

	/**
	 * Init component
	 *
	 */
	this.init = function() {		

		// get settings and labels
		currencyConverter.getSettingsAndLabelsJsonData();		
		currencyConverter.formatMoneyInputs();

		// generate regex from settings to format numbers
		regexSeparator = new RegExp('\\' + genericSettings.separator, 'g');
		regexDecimal = new RegExp('\\' + genericSettings.decimal, 'g');

		if($("[data-currency]").length>0){

			var dCurr = $("[data-currency]");

			dCurr.on('input change',function(){

				var toAmount = $("[data-currency=toAmount]").val();
				var toAmountCurrency = $("[data-currency=toAmountCurrency] select").val();
				var fromAmount = $("[data-currency=fromAmount]").val();
				if (bankName == "VUB") {
					var fromAmountCurrency = $('[data-currency=fromAmountCurrency]').text();
				} else{
					var fromAmountCurrency = $("[data-currency=fromAmountCurrency] select").val();
				}			
				
				
				// parse currency values
				try {
					toAmount = parseFloat(toAmount.replace(regexSeparator, '').replace(regexDecimal, '.'));
					fromAmount = parseFloat(fromAmount.replace(regexSeparator, '').replace(regexDecimal, '.'));
				} catch(e) {
					toAmount = 0;
					fromAmount = 0;
					console.error('TypeError: Unable to parse currency converter fromAmount/toAmount values');
				}

				if ( (toAmount!==undefined) && (toAmountCurrency!==undefined) && (fromAmount!==undefined) && (fromAmountCurrency!==undefined)){
					
					
					if($(this).attr("data-currency")=="toAmount"){

						currencyConverter.calculateConversionToAmount(toAmount,toAmountCurrency,fromAmount,fromAmountCurrency);

					} else{

						currencyConverter.calculateConversionFromAmount(toAmount,toAmountCurrency,fromAmount,fromAmountCurrency);

					}					
	
				}

				
				currencyConverter.formatMoneyInputs();

			});
			
			
			
			if(bankName == "BIB"){
				$('select[name="selectedFromCurrencyCode"]').on('change', function(e){
					var select = $('select[name="selectedToCurrencyCode"]');
					var value = $(this).val();
					if(value != "RSD"){
						select.find("option[value=EUR_NET]").hide();
					} else {
						select.find("option[value=EUR_NET]").show();

					}
				});
				$('select[name="selectedToCurrencyCode"]').on('change', function(e){
					var select = $('select[name="selectedFromCurrencyCode"]');
					var value = $(this).val();
					if(value != "RSD"){
						select.find("option[value=EUR_NET]").hide();
					} else {
						select.find("option[value=EUR_NET]").show();

					}
				});
				$('select[name="selectedFromCurrencyCode"]').on('click', function(e){
					var select = $('select[name="selectedToCurrencyCode"]');
					var attr = select.attr("disabled");
					if(typeof attr !== 'undefined' && attr !== false){
						select.removeAttr("disabled");
					}
					var value = $(this).val();
					if(value == 'EUR_NET'){
						select.val("RSD");
						select.attr('disabled', 'disabled');
					}
				});

				$('select[name="selectedToCurrencyCode"]').on('click', function(e){
					var select = $('select[name="selectedFromCurrencyCode"]');
					var attr = select.attr("disabled");
					if(typeof attr !== 'undefined' && attr !== false){
						select.removeAttr("disabled");
					}
					var value = $(this).val();
					if(value == 'EUR_NET'){
						select.val("RSD");
						select.attr('disabled', 'disabled');
					}
				});
			}

		}
		
		if($("[data-cash-no-cash-currency]").length>0){
			
			var cashNoCashCurr = $("[data-cash-no-cash-currency]");

			cashNoCashCurr.on('input change',function(){
				
				var fromAmount = $("[data-cash-no-cash-currency=fromAmount]").val();
				var toAmountCurrency = $("[data-cash-no-cash-currency=toAmountCurrency]").val();
				var fromAmountCurrency = $("[data-cash-no-cash-currency=fromAmountCurrency]").val();
				var changeTypeCurrency = $("[data-cash-no-cash-currency=changeTypeCurrency]:checked").val();
				
				$("[data-cash-no-cash-currency='resultAmountFXCurrency']").val(toAmountCurrency);
				$("[data-cash-no-cash-currency='resultAmountCashCurrency']").val(toAmountCurrency);
				
				// parse currency values
				try {
					fromAmount = parseFloat(fromAmount.replace(regexSeparator, '').replace(regexDecimal, '.'));
				} catch(e) {
					fromAmount = 0;
					console.error('TypeError: Unable to parse currency converter fromAmount values');
				}

				if ( (toAmountCurrency!==undefined) && (fromAmount!==undefined) && (fromAmountCurrency!==undefined) && (changeTypeCurrency!==undefined)){
					currencyConverter.calculateConversionCashNoCashAmount(toAmountCurrency,fromAmount,fromAmountCurrency, changeTypeCurrency);			
				}
				currencyConverter.formatMoneyInputs();
				
			});
			
		}

	}

	this.calculateConversionToAmount = function(toAmount,toAmountCurrency,fromAmount,fromAmountCurrency){

		var calculatedValue = 0;
		var sellRate = 0;
		var meanRate = 0;

		if(toAmountCurrency!==fromAmountCurrency){
			
			if(bankName!="ISPSLOVENIA" && bankName!="VUB"){

				if (fromAmountCurrency=="JPY"){
					toAmount = toAmount*100;
				}

				if (toAmountCurrency=="JPY"){
					toAmount = toAmount/100;
				}			
			}
		}			
		

		if( !$.isEmptyObject(currencyConverter.cJson) ){

			if (currencyConverter.cJson.rates!==undefined){

				if(toAmountCurrency==fromAmountCurrency){
					calculatedValue = toAmount;
				}

				
				else if(toAmountCurrency==currencyConverter.localCurrencyLbl){

					for(var i=0;i<currencyConverter.cJson.rates.length;i++){

						if((currencyConverter.cJson.rates[i].toCurrency.label==fromAmountCurrency)
						&& (currencyConverter.cJson.rates[i].fromCurrency.label==toAmountCurrency)){
							sellRate = currencyConverter.cJson.rates[i].sellingRate.rate;
							
							meanRate = currencyConverter.cJson.rates[i].meanRate.rate;
							
							if(bankName == "ISPSLOVENIA" || bankName == "PBZ" ){
								
								calculatedValue = (toAmount*sellRate).toFixed(currencyConverter.numeralDecimalScale);
								
							} else if(bankName == "VUB"){
								
								calculatedValue = (toAmount*meanRate).toFixed(currencyConverter.numeralDecimalScale);
								
							} else {
								console.log("condizione per banca bib " + bankName == "BIB" && fromAmountCurrency != currencyConverter.localCurrencyLbl &&  toAmountCurrency == currencyConverter.localCurrencyLbl);
								
								if(bankName == "BIB" && fromAmountCurrency != currencyConverter.localCurrencyLbl &&  toAmountCurrency == currencyConverter.localCurrencyLbl){
									var buyRate = currencyConverter.cJson.rates[i].buyRate.rate;
									calculatedValue = (toAmount/buyRate).toFixed(currencyConverter.numeralDecimalScale);								

								} else {
									calculatedValue = (toAmount/sellRate).toFixed(currencyConverter.numeralDecimalScale);								
								}
							}
								
						}
		
					}				

				} else{

					for(var i=0;i<currencyConverter.cJson.rates.length;i++){

						if((currencyConverter.cJson.rates[i].toCurrency.label==toAmountCurrency)
							&& (currencyConverter.cJson.rates[i].fromCurrency.label==currencyConverter.localCurrencyLbl)){
		
							var buyRate = currencyConverter.cJson.rates[i].buyRate.rate;

							meanRate = currencyConverter.cJson.rates[i].meanRate.rate;

							if(bankName=="BIB"){
								if(bankName == "BIB" && fromAmountCurrency == currencyConverter.localCurrencyLbl &&  toAmountCurrency != currencyConverter.localCurrencyLbl){
									buyRate = currencyConverter.cJson.rates[i].sellingRate.rate;
									calculatedValue = (toAmount*buyRate).toFixed(currencyConverter.numeralDecimalScale);								

								} else {
									buyRate = currencyConverter.cJson.rates[i].meanRate.rate;
								}
							}
							if(bankName=="ISPSLOVENIA" || bankName == "PBZ"){
								
								calculatedValue = toAmount/buyRate;	
								
							} else if(bankName == "VUB"){
								
								calculatedValue = toAmount/meanRate;	
								
							}  else {
								
								calculatedValue = toAmount*buyRate;	
								
							}
		
						}							
		
					}
		
					for (var j = 0; j < currencyConverter.cJson.rates.length; j++) {

						if ((currencyConverter.cJson.rates[j].toCurrency.label == fromAmountCurrency)
							&& (currencyConverter.cJson.rates[j].fromCurrency.label == currencyConverter.localCurrencyLbl)) {

							sellRate = currencyConverter.cJson.rates[j].sellingRate.rate;

							meanRate = currencyConverter.cJson.rates[j].meanRate.rate;

							if (bankName == "ISPSLOVENIA" || bankName == "PBZ") {

								calculatedValue = (calculatedValue * sellRate).toFixed(currencyConverter.numeralDecimalScale);

							} else if (bankName == "VUB") {

								calculatedValue = (calculatedValue * meanRate).toFixed(currencyConverter.numeralDecimalScale);

							}
							else {

								calculatedValue = (calculatedValue / sellRate).toFixed(currencyConverter.numeralDecimalScale);

							}


						}

					}				
		
				}					

			}
			
		}

		// Replace decimal separator or cleave.js will not work properly
		if (genericSettings.decimal == ',') {
			calculatedValue = calculatedValue.toString().replace(/\./g, ',');
		}

		$('[data-currency="fromAmount"]').val(calculatedValue);

	}

	this.calculateConversionFromAmount = function(toAmount,toAmountCurrency,fromAmount,fromAmountCurrency){

		var calculatedValue = 0;
		var sellRate = 0;

		if(toAmountCurrency!==fromAmountCurrency){

			if(bankName!="ISPSLOVENIA" && bankName!="VUB"){
				if (fromAmountCurrency=="JPY"){
					fromAmount = fromAmount/100;
				}
	
				if (toAmountCurrency=="JPY"){
					fromAmount = fromAmount*100;
				}			
			}
		}			

		if( !$.isEmptyObject(currencyConverter.cJson) ){

			if (currencyConverter.cJson.rates!==undefined){

				if(toAmountCurrency==fromAmountCurrency){
					calculatedValue = fromAmount;
				}	
				
				else if(fromAmountCurrency==currencyConverter.localCurrencyLbl){

					
					for(var i=0;i<currencyConverter.cJson.rates.length;i++){

						if((currencyConverter.cJson.rates[i].toCurrency.label==toAmountCurrency)
							&& (currencyConverter.cJson.rates[i].fromCurrency.label==fromAmountCurrency)){

							sellRate = currencyConverter.cJson.rates[i].sellingRate.rate;
							
							meanRate = currencyConverter.cJson.rates[i].meanRate.rate;

							if(bankName=="ISPSLOVENIA" || bankName == "PBZ" ){
								
								calculatedValue = (fromAmount * sellRate).toFixed(currencyConverter.numeralDecimalScale);
								
							} else if (bankName == "VUB") {

								calculatedValue = (fromAmount * meanRate).toFixed(currencyConverter.numeralDecimalScale);

							} else {
								
								calculatedValue = (fromAmount/sellRate).toFixed(currencyConverter.numeralDecimalScale);
							
							} 
								
						}

					}				

				} else{

					for(var i=0;i<currencyConverter.cJson.rates.length;i++){

						if((currencyConverter.cJson.rates[i].toCurrency.label==fromAmountCurrency)
							&& (currencyConverter.cJson.rates[i].fromCurrency.label==currencyConverter.localCurrencyLbl)){

							var buyRate = currencyConverter.cJson.rates[i].buyRate.rate;

							meanRate = currencyConverter.cJson.rates[i].meanRate.rate;

							if(bankName=="BIB"){
								
								buyRate = currencyConverter.cJson.rates[i].meanRate.rate;
							}
							if(bankName=="ISPSLOVENIA" || bankName == "PBZ" ){
							
								calculatedValue = fromAmount/buyRate;
								
							} else if(bankName == "VUB"){
								
								calculatedValue = fromAmount/meanRate;	
								
							}  else {
								console.log("condizione per banca bib " + bankName == "BIB" && fromAmountCurrency != currencyConverter.localCurrencyLbl &&  toAmountCurrency == currencyConverter.localCurrencyLbl);
								if(bankName == "BIB" && fromAmountCurrency != currencyConverter.localCurrencyLbl &&  toAmountCurrency == currencyConverter.localCurrencyLbl){
									buyRate = currencyConverter.cJson.rates[i].buyRate.rate;
									calculatedValue = (fromAmount*buyRate).toFixed(currencyConverter.numeralDecimalScale);								

								} else {
									calculatedValue = fromAmount*buyRate;
								}
							} 
							

						}							

					}

					for(var j=0;j<currencyConverter.cJson.rates.length;j++){

						if((currencyConverter.cJson.rates[j].toCurrency.label==toAmountCurrency)
							&& (currencyConverter.cJson.rates[j].fromCurrency.label==currencyConverter.localCurrencyLbl)){
								
							sellRate = currencyConverter.cJson.rates[j].sellingRate.rate;	
							
							meanRate = currencyConverter.cJson.rates[j].meanRate.rate;

							if(bankName=="ISPSLOVENIA" || bankName == "PBZ" ){
								
								calculatedValue = (calculatedValue * sellRate).toFixed(currencyConverter.numeralDecimalScale);
								
							} else if (bankName == "VUB") {

								calculatedValue = (calculatedValue * meanRate).toFixed(currencyConverter.numeralDecimalScale);

							} else{
								
								calculatedValue = (calculatedValue/sellRate).toFixed(currencyConverter.numeralDecimalScale);
								
							}

						}	
					
					}	

				}	
					
			}		

		}

		// Replace decimal separator or cleave.js will not work properly
		if (genericSettings.decimal == ',') {
			calculatedValue = calculatedValue.toString().replace(/\./g, ',');
		}

		$('[data-currency="toAmount"]').val(calculatedValue);

	}
	
	
	
	this.calculateConversionCashNoCashAmount = function(toAmountCurrency,fromAmount,fromAmountCurrency, changeTypeCurrency){

		var sellRate = 0;
		var sellRateCash = 0;
		var buyRate = 0;
		var buyRateCash = 0;
		var calculatedValue = 0;
		var calculatedValueCash = 0;
		var fromAmountCurrencyDefault = $("[data-cash-no-cash-currency=converterCurrencyDefault]").val();

		if( !$.isEmptyObject(currencyConverter.cJson) ){

			if (currencyConverter.cJson.rates!==undefined){
				
				if(toAmountCurrency == fromAmountCurrency){
					
					calculatedValue = fromAmount;
					calculatedValueCash = fromAmount;

				} else if(fromAmountCurrency == fromAmountCurrencyDefault){
				
					for(var i=0;i<currencyConverter.cJson.rates.length;i++){
						if((currencyConverter.cJson.rates[i].fromCurrency.label==fromAmountCurrency)
							&& (currencyConverter.cJson.rates[i].toCurrency.label==toAmountCurrency)){
							buyRate = currencyConverter.cJson.rates[i].buyRate.rate;
							buyRateCash = currencyConverter.cJson.rates[i].buyRateCash.rate;
							sellRate = currencyConverter.cJson.rates[i].sellingRate.rate;
							sellRateCash = currencyConverter.cJson.rates[i].sellingRateCash.rate;
							unit = currencyConverter.cJson.rates[i].buyRate.units;
							if(changeTypeCurrency == "buySelected"){
								if(buyRate==null){
									calculatedValue = 0;
								} else {
									calculatedValue = fromAmount/buyRate;
								}
								if(buyRateCash==null){
									calculatedValueCash = 0;
								} else {
									calculatedValueCash = fromAmount/buyRateCash;
								}
							} else {
								if(sellRate==null){
									calculatedValue = 0;
								} else {
									calculatedValue = fromAmount/sellRate;
								}
								if(sellRateCash==null){
									calculatedValueCash = 0;
								} else {
									calculatedValueCash = fromAmount/sellRateCash;
								}
							}
							calculatedValue = calculatedValue * unit;
							calculatedValueCash = calculatedValueCash * unit;
						}
					}

				} else if(toAmountCurrency == fromAmountCurrencyDefault){
				
					for(var i=0;i<currencyConverter.cJson.rates.length;i++){
						if((currencyConverter.cJson.rates[i].fromCurrency.label==toAmountCurrency)
							&& (currencyConverter.cJson.rates[i].toCurrency.label==fromAmountCurrency)){
							buyRate = currencyConverter.cJson.rates[i].buyRate.rate;
							buyRateCash = currencyConverter.cJson.rates[i].buyRateCash.rate;
							sellRate = currencyConverter.cJson.rates[i].sellingRate.rate;
							sellRateCash = currencyConverter.cJson.rates[i].sellingRateCash.rate;
							unit = currencyConverter.cJson.rates[i].buyRate.units;
							if(changeTypeCurrency == "buySelected"){
								if(sellRate==null){
									calculatedValue = 0;
								} else {
									calculatedValue = fromAmount*sellRate;
								}
								if(sellRateCash==null){
									calculatedValueCash = 0;
								} else {
									calculatedValueCash = fromAmount*sellRateCash;
								}
							} else {
								if(buyRate==null){
									calculatedValue = 0;
								} else {
									calculatedValue = fromAmount*buyRate;
								}
								if(buyRateCash==null){
									calculatedValueCash = 0;
								} else {
									calculatedValueCash = fromAmount*buyRateCash;
								}
							}
							calculatedValue = calculatedValue / unit;
							calculatedValueCash = calculatedValueCash / unit;
						}
					}

				} else {
					
					var calculatedValueStep1;
					var calculatedValueCashStep1;
					
					if(changeTypeCurrency == "buySelected"){
						for(var i=0;i<currencyConverter.cJson.rates.length;i++){
							if((currencyConverter.cJson.rates[i].fromCurrency.label==fromAmountCurrencyDefault)
								&& (currencyConverter.cJson.rates[i].toCurrency.label==toAmountCurrency)){
								buyRate = currencyConverter.cJson.rates[i].buyRate.rate;
								buyRateCash = currencyConverter.cJson.rates[i].buyRateCash.rate;
								sellRate = currencyConverter.cJson.rates[i].sellingRate.rate;
								sellRateCash = currencyConverter.cJson.rates[i].sellingRateCash.rate;
								unit = currencyConverter.cJson.rates[i].buyRate.units;
								if(buyRate==null){
									calculatedValueStep1 = 0;
								} else {
									calculatedValueStep1 = fromAmount/buyRate;
								}
								if(buyRateCash==null){
									calculatedValueCashStep1 = 0;
								} else {
									calculatedValueCashStep1 = fromAmount/buyRateCash;
								}
								calculatedValueStep1 = calculatedValueStep1 * unit;
								calculatedValueCashStep1 = calculatedValueCashStep1 * unit;
							}
						}
						for(var j=0;j<currencyConverter.cJson.rates.length;j++){
							if((currencyConverter.cJson.rates[j].fromCurrency.label==fromAmountCurrencyDefault)
								&& (currencyConverter.cJson.rates[j].toCurrency.label==fromAmountCurrency)){
								buyRate = currencyConverter.cJson.rates[j].buyRate.rate;
								buyRateCash = currencyConverter.cJson.rates[j].buyRateCash.rate;
								sellRate = currencyConverter.cJson.rates[j].sellingRate.rate;
								sellRateCash = currencyConverter.cJson.rates[j].sellingRateCash.rate;
								unit = currencyConverter.cJson.rates[j].buyRate.units;
								if(sellRate==null){
									calculatedValue = 0;
								} else {
									calculatedValue = calculatedValueStep1*sellRate;
								}
								if(sellRateCash==null){
									calculatedValueCash = 0;
								} else {
									calculatedValueCash = calculatedValueCashStep1*sellRateCash;
								}
								calculatedValue = calculatedValue / unit;
								calculatedValueCash = calculatedValueCash / unit;
							}
						}
					} else {
						for(var i=0;i<currencyConverter.cJson.rates.length;i++){
							if((currencyConverter.cJson.rates[i].fromCurrency.label==fromAmountCurrencyDefault)
								&& (currencyConverter.cJson.rates[i].toCurrency.label==fromAmountCurrency)){
								buyRate = currencyConverter.cJson.rates[i].buyRate.rate;
								buyRateCash = currencyConverter.cJson.rates[i].buyRateCash.rate;
								sellRate = currencyConverter.cJson.rates[i].sellingRate.rate;
								sellRateCash = currencyConverter.cJson.rates[i].sellingRateCash.rate;
								unit = currencyConverter.cJson.rates[i].buyRate.units;
								if(buyRate==null){
									calculatedValueStep1 = 0;
								} else {
									calculatedValueStep1 = fromAmount*buyRate;
								}
								if(buyRateCash==null){
									calculatedValueCashStep1 = 0;
								} else {
									calculatedValueCashStep1 = fromAmount*buyRateCash;
								}
								calculatedValueStep1 = calculatedValueStep1 / unit;
								calculatedValueCashStep1 = calculatedValueCashStep1 / unit;
							}
						}
						for(var j=0;j<currencyConverter.cJson.rates.length;j++){
							if((currencyConverter.cJson.rates[j].fromCurrency.label==fromAmountCurrencyDefault)
								&& (currencyConverter.cJson.rates[j].toCurrency.label==toAmountCurrency)){
								buyRate = currencyConverter.cJson.rates[j].buyRate.rate;
								buyRateCash = currencyConverter.cJson.rates[j].buyRateCash.rate;
								sellRate = currencyConverter.cJson.rates[j].sellingRate.rate;
								sellRateCash = currencyConverter.cJson.rates[j].sellingRateCash.rate;
								unit = currencyConverter.cJson.rates[j].buyRate.units;
								if(sellRate==null){
									calculatedValue = 0;
								} else {
									calculatedValue = calculatedValueStep1/sellRate;
								}
								if(sellRateCash==null){
									calculatedValueCash = 0;
								} else {
									calculatedValueCash = calculatedValueCashStep1/sellRateCash;
								}
								calculatedValue = calculatedValue * unit;
								calculatedValueCash = calculatedValueCash * unit;
							}
						}
					}
					
				}
				
			}		

		}
		
		calculatedValue = calculatedValue.toFixed(currencyConverter.numeralDecimalScale);
		calculatedValueCash = calculatedValueCash.toFixed(currencyConverter.numeralDecimalScale);

		// Replace decimal separator or cleave.js will not work properly
		if (genericSettings.decimal == ',') {
			calculatedValue = calculatedValue.toString().replace(/\./g, ',');
			calculatedValueCash = calculatedValueCash.toString().replace(/\./g, ',');
		}
		
		if(calculatedValue==0 || calculatedValue=="0" || calculatedValue=="0.00" || calculatedValue=="0,00"){
			calculatedValue="-";
		}
		if(calculatedValueCash==0 || calculatedValueCash=="0" || calculatedValueCash=="0.00"  || calculatedValueCash=="0,00"){
			calculatedValueCash="-";
		}

		$('[data-cash-no-cash-currency="resultAmountFX"]').val(calculatedValue);
		$('[data-cash-no-cash-currency="resultAmountCash"]').val(calculatedValueCash);

	}
	
	

	/**
	 * Format Money Inputs
	 *
	 */
	this.formatMoneyInputs = function() {

		var inputToFormat = $( '*[data-format-currency]');

		if( inputToFormat.length ) {			

			inputToFormat.each( function() {

				var cleave = new Cleave( $(this), {

					delimiter: genericSettings.separator,
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: currencyConverter.numeralDecimalScale,
					numeralThousandsGroupStyle: 'thousand'

				} );

			} );

		}

	};	

};

/**
 * Get class instance
 *
 */
Intesa.CurrencyConverter.getInstance = function() {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.currencyConverter ) {
		
		window.intesa.currencyConverter = new Intesa.CurrencyConverter();
		
	}
	
	return window.intesa.currencyConverter;

};
